import React, { FunctionComponent } from 'react'
import { Checkbox } from '../../form'
import ComparisonResultCategory from '../../../entities/ComparisonResultCategory'
import useTranslation from '../../../hooks/useTranslation'
import style from './comparisonPdfFilters.css'

export type Props = {
    availableCategories: ComparisonResultCategory[]
    selectedCategories: Set<string>
    onlyDifferent: boolean
    onCategoryToggle: (categoryId: string) => void
    onOnlyDifferentChange: (onlyDifferent: boolean) => void
}

const ComparisonPdfFilters: FunctionComponent<Props> = (props) => {
    const { availableCategories, selectedCategories, onlyDifferent, onCategoryToggle, onOnlyDifferentChange } = props
    const { t } = useTranslation()

    return (
        <div className={style.filtersSection}>
            <div className={style.categoryFilters}>
                <div className={style.checkboxGroup}>
                    {availableCategories.map(category => (
                        <label key={category.id} className={style.checkboxLabel}>
                            <Checkbox
                                checked={selectedCategories.has(category.id)}
                                onChange={() => onCategoryToggle(category.id)}
                            />
                            <span>{t('compare.categories.' + category.id, category.name)}</span>
                        </label>
                    ))}
                    <label className={style.checkboxLabel}>
                        <Checkbox
                            checked={onlyDifferent}
                            onChange={(event) => onOnlyDifferentChange(event.target.checked)}
                        />
                        <span>{t('compare.onlyDifferentText')}</span>
                    </label>
                </div>
            </div>
        </div>
    )
}

export default ComparisonPdfFilters
